import { Pipe, PipeTransform } from '@angular/core';

import { DAYS_PIPE_INTERVAL } from '../constants/data.constants';

@Pipe({
  name: 'daysAgo',
  standalone: false,
})
export class DaysAgoPipe implements PipeTransform {
  public transform(value: string | Date): string {
    if (!value) {
      return '';
    }

    const now = new Date();
    const date = new Date(value);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const interval = DAYS_PIPE_INTERVAL;

    for (const unit of Object.keys(interval) as Array<keyof typeof interval>) {
      const time = Math.floor(seconds / interval[unit]);
      if (time >= 1) {
        const label = time === 1 ? unit : `${unit}s`;
        return `${time} ${label} ago`;
      }
    }

    return 'just now';
  }
}
